import { ReactNode } from 'react'
import { LineChartOutlined, PlayCircleOutlined } from '@ant-design/icons'

export interface HubLink {
  key: string
  label: string
  path: string
  icon: ReactNode
  analyticsId: string
  testId: string
}

export const HUB_LINKS: Array<HubLink> = [
  {
    key: 'playwright',
    label: 'Playwright dashboard',
    path: '/playwright',
    icon: <PlayCircleOutlined />,
    analyticsId: 'hubPlaywrightDashboard',
    testId: 'hubPlaywrightDashboard',
  },
  {
    key: 'performance',
    label: 'Performance Metrics',
    path: '/performance',
    icon: <LineChartOutlined />,
    analyticsId: 'hubPerformanceMetrics',
    testId: 'hubPerformanceMetrics',
  },
]
